/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @getify/proper-ternary/nested */
import { Drawer, Tab, Tabs, Box } from '@material-ui/core';
import styled from 'styled-components/macro';
import styledMixins from 'app/styles/styledMixins';
import React, { useState } from 'react';
import Button from 'app/shared/components/button/Button';
import { RepairCase } from 'app/core/api/repairer/api-repairer.types';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import { makeStyles } from '@material-ui/core/styles';
import Form from 'app/shared/frames/Form';
import FormTextInput from 'app/shared/components/form-input/FormTextInput';
import useInputForm from 'app/shared/components/form-input/utilities/use-input-form';
import {
  WarrantyCoveredInput,
  WarrantyCoveredReq,
} from 'app/core/api/warranty-covered/api-warranty-covered.types';
import { useCreateRepairCaseWarrantyCovered } from 'app/core/api/warranty-covered/api-warranty-covered';
import {
  GENERAL_MAX_LENGTH,
  maxLengthRule,
} from 'app/shared/components/form-input/utilities/form-tools';
import styledFuncs from 'app/styles/styledFuncs';
import ClassName from 'app/styles/ClassName';
import styledConsts from 'app/styles/styledConsts';

const rules = maxLengthRule(GENERAL_MAX_LENGTH);

const QuoteTabs = styled(Tabs)`
  ${styledMixins.softShadow}
`;

const SkipButtonContainer = styled.div`
  text-align: center;
  margin-top: ${styledFuncs.pad()};
`;

const SkipButton = styled(Button).attrs({
  slim: true,
  className: ClassName.NO_HEIGHT_MARGIN,
})`
  margin-top: ${styledFuncs.pad()};
  margin-bottom: ${styledFuncs.pad(0.5)};
  color: ${styledConsts.cError};
  background-color: transparent;
  padding: 0;
  min-height: 0;
  margin: 0;
  &:hover {
    background-color: transparent;
  }
`;
const TabPanel: React.FC<{ index: number; activeTab: number }> = ({
  children,
  index,
  activeTab,
}) => (
  <div
    role="tabpanel"
    id={`wrapped-tabpanel-${index}`}
    aria-labelledby={`wrapped-tab-${index}`}
    css={`
      flex: 1 1 100%;
      display: ${activeTab === index ? 'flex' : 'none'};
    `}
  >
    {activeTab === index && children}
  </div>
);

const useStyles = makeStyles({
  drawerPaper: {
    maxHeight: 518,
  },
});

type Props = {
  tabTitle: string;
  isCommentDrawerOpen: boolean;
  SetIsCommentDrawerOpen: (isVisible: boolean) => unknown;
  SetIsQuoteOpen: () => boolean | void;
  repairCase: RepairCase | undefined;
  loadRepairCaseApi: () => boolean | void;
};
export default function ProductComments({
  tabTitle,
  isCommentDrawerOpen,
  SetIsCommentDrawerOpen,
  SetIsQuoteOpen,
  repairCase,
  loadRepairCaseApi,
}: Props): JSX.Element {
  const {
    request$: createWarrantyCovered$,
    sending: createWarrantyCoverage,
  } = useCreateRepairCaseWarrantyCovered();

  const [activeTab, setActiveTab] = useState(0);
  const [comments, setComments] = useState('');

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { handleSubmit, inputProps } =
    useInputForm<WarrantyCoveredInput>({});

  const onTabChange = (val: unknown) => {
    setActiveTab(val as number);
  };
  const { showDialog } = useShowInfo();
  const classes = useStyles();
  // useEffectOnChanges(() => {
  //   if (apiError && apiError.errorMessage) {
  //     showSnack({ message: apiError.errorMessage ?? '' });
  //   }
  // }, [apiError, showSnack]);

  // formValues: WarrantyCoveredInput
  const onSubmit = () => {
    const warrantyCoveredReq: WarrantyCoveredReq = {
      repaircaseId: repairCase?.id,
      warrantyCovered: ' ',
      repairerComments: comments || ' ',
    };
    createWarrantyCovered$(warrantyCoveredReq).subscribe(() => {
      // setValue('warrantyCovered', 'false');
      // setWarrantyCoverage('false');
      // setValue('repairerComments', '');
      SetIsCommentDrawerOpen(!isCommentDrawerOpen);
      if (repairCase?.caseStatus === 'diagnosis_completed') {
        showDialog({
          title: 'Diagnosis comments submitted',
          message: <div>Would you like to issue a repair quote?</div>,
          onDismissed: () => {},
          actions: [
            {
              text: 'No',
            },
            { text: 'Yes', callback: SetIsQuoteOpen },
          ],
        });
      } else {
        loadRepairCaseApi();
      }
    });
  };

  // const handleClick = () => {
  //   payment.current?.scrollIntoView({
  //     behavior: 'smooth',
  //     block: 'start',
  //     inline: 'start',
  //   });
  // };

  return (
    <>
      <Drawer
        anchor="bottom"
        open={isCommentDrawerOpen}
        onClose={() => SetIsCommentDrawerOpen(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div
          style={{
            position: 'fixed',
            width: '100%',
            backgroundColor: '#fff',
            zIndex: 1,
          }}
        >
          <QuoteTabs
            value={activeTab}
            onChange={(e, val) => onTabChange(val)}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            style={{ zIndex: 999 }}
          >
            <Tab value={0} label={tabTitle} />
          </QuoteTabs>
        </div>
        <div style={{ position: 'relative', marginTop: '30px' }}>
          <TabPanel index={0} {...{ activeTab }}>
            <div
              style={{
                display: 'block',
                margin: '20px',
                overflowY: 'scroll',
                width: '100%',
              }}
            >
              <Form onSubmit={handleSubmit(onSubmit)}>
                <FormTextInput
                  optional
                  classicPlaceholder
                  controlName="repairerComments"
                  placeholder="Type something here..."
                  onChange={evt => {
                    setComments(evt.target.value);
                  }}
                  InputProps={{
                    inputProps: {
                      maxLength: 200,
                    },
                  }}
                  value={comments}
                  multiline
                  {...{ rules }}
                  {...inputProps}
                />
                <span
                  style={{
                    margin: '-10px 0 0 0',
                    textAlign: 'end',
                    padding: '0 10px',
                  }}
                >
                  {comments.length}/200 character used
                </span>
                <Box position="relative">
                  <Button
                    type="submit"
                    variant="outlined"
                    size="medium"
                    pending={createWarrantyCoverage}
                    style={{
                      minHeight: '40px',
                      padding: '0 25px',
                      width: '100%',
                    }}
                  >
                    Submit
                  </Button>
                  <SkipButtonContainer>
                    <SkipButton
                      onClick={() => SetIsCommentDrawerOpen(false)}
                    >
                      Cancel
                    </SkipButton>
                  </SkipButtonContainer>
                </Box>
              </Form>
            </div>
          </TabPanel>
        </div>
      </Drawer>
    </>
  );
}
